import { nanoid } from 'nanoid/non-secure';
export const LOCAL_STORAGE_IMEI_KEY = 'insta_fe_imei';

/** 获取用户设备号，由于设备的IMEI是系统级别的信息，所以获取不到，这里的做法是在localstorage种一个唯一id来做为IMEI */
export const getIMEI = () => {
  if (!window || !window.localStorage) return '';

  // 获取localStorage中的IMEI
  let IMEI = localStorage.getItem(LOCAL_STORAGE_IMEI_KEY);

  // 没有则存一个，并返回
  if (!IMEI) {
    IMEI = nanoid(10);
    localStorage.setItem(LOCAL_STORAGE_IMEI_KEY, IMEI);
  }

  return IMEI;
};
